export default __webpack_public_path__ + "static/media/23.a882ac68.jpeg";